import { render, staticRenderFns } from "./AppFatList.vue?vue&type=template&id=904eba62&"
import script from "./AppFatList.vue?vue&type=script&lang=js&"
export * from "./AppFatList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports